import React from "react";
import { StarFilled, StarOutlined } from "@ant-design/icons";
function FarmerInfo({ info }) {

  return (
    <div className="flex flex-row justify-between font-body bg-white p-5 rounded-2xl ">
         <div className=" hidden max-lg:block m-auto rounded-full bg-slate-300 overflow-hidden w-[5rem] h-[3.5rem]">
            <img src={info?.farmer?.avatarUrl} alt="avatar" />
          </div>
      <div className="flex flex-row justify-between gap-10 w-full font-body bg-white p-5 rounded-2xl  max-lg:flex  max-lg:text-[0.625rem] max-lg:font-normal max-lg:gap-1">
        <div className="flex flex-row items-center gap-2  max-lg:hidden">
          <div className="rounded-full bg-slate-300 overflow-hidden w-[4rem] max-lg: h-[4rem]">
            <img src={info?.farmer?.avatarUrl} alt="avatar" />
          </div>
          <p >
            {info?.farmer?.firstName} {info?.farmer?.lastName}
          </p>
        </div>
        <section className="flex flex-row max-lg:m-auto max-lg:flex-col items-center m-auto gap-20 max-lg:gap-2 max-lg:text-justify">
          <div className="hidden max-lg:block ">
            <p>
              {info?.farmer?.firstName} {info?.farmer?.lastName}
            </p>
          </div>
          <div className="flex flex-row  gap-2">
            <p>شماره تماس:</p>
            <p>{info?.farmer?.phoneNumber}</p>
          </div>
          <div className="flex flex-row  gap-2">
            <p>کد کشاورزی:</p>
            <p>{info?.farmer?.farmerCode}</p>
          </div>
          <div className="flex flex-row  gap-2">
            <p>منطقه:</p>
            <p>
              {info?.farmer?.province} {info?.farmer?.city}
            </p>
          </div>
        </section>
      </div>
      {info?.farmer?.marked ? (
        <StarFilled className="text-yellow-300 text-4xl" />
      ) : (
        <StarOutlined className="text-4xl" />
      )}
    </div>
  );
}

export default FarmerInfo;
